// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-close/modal-close.scss
// module id = 526
// module chunks = 0